import * as s from '~js/utils/selectors';
import * as a from '~js/utils/attributes';
import * as c from '~js/utils/classes';
import { Tabs } from '~js/components/tabs';
import { ProductGrid } from '~js/components/product-grid';
import { GridSlider } from '~js/components/grid-slider';
import { CustomScrollbar } from '~js/components/custom-scrollbar';
import { Tooltip } from '~js/components/tooltip';

export class RelatedProducts {
  constructor(section) {
    this.section = section;
    this.sectionId = section.id;
    this.container = section.container;

    this.related();
    this.recent();

    this.tabs = new Tabs(this.container);
  }

  related() {
    this.relatedProducts = this.container.querySelector(s.selectors$5.relatedProducts);

    if (!this.relatedProducts) {
      return;
    }

    const sectionId = this.container.getAttribute(a.attributes$4.sectionId);
    const productId = this.container.getAttribute(a.attributes$4.productId);
    const limit = this.container.getAttribute(a.attributes$4.limit);
    const requestUrl = `${theme.routes.product_recommendations_url}?section_id=${sectionId}&limit=${limit}&product_id=${productId}`;

    fetch(requestUrl)
      .then((response) => {
        if (!response.ok) {
          const error = new Error(response.status);
          this.hideRelated();
          throw error;
        }
        return response.text();
      })
      .then((data) => {
        const createdElement = document.createElement('div');
        createdElement.innerHTML = data;
        const inner = createdElement.querySelector(s.selectors$5.relatedProducts);

        if (inner.querySelectorAll(s.selectors$5.product).length) {
          this.relatedProducts.innerHTML = inner.innerHTML;

          this.relatedProductGrid = new ProductGrid(this.relatedProducts);
          this.relatedGridSlider = new GridSlider(this.relatedProducts);
          this.initTooltips(this.relatedProducts);
        }
      });
  }

  recent() {
    const recentlyViewed = this.container.querySelector(s.selectors$5.recentlyViewed);
    const howManyToshow = recentlyViewed ? parseInt(recentlyViewed.getAttribute(a.attributes$4.limit)) : 4;

    Shopify.Products.showRecentlyViewed({
      howManyToShow: howManyToshow,
      wrapperId: `recently-viewed-products-${this.sectionId}`,
      section: this.section,
      onComplete: (wrapper, section) => {
        const container = section.container;
        const recentlyViewedHolder = container.querySelector(s.selectors$5.recentlyViewed);
        const recentlyViewedWrapper = container.querySelector(s.selectors$5.recentlyViewedWrapper);
        const recentProducts = wrapper.querySelectorAll(s.selectors$5.product);
        const aosItem = container.querySelectorAll(s.selectors$5.aos);
        const slider = recentlyViewedHolder.querySelector(s.selectors$5.slider);
        const minimumNumberProducts = recentlyViewedHolder.hasAttribute(a.attributes$4.minimum)
          ? parseInt(recentlyViewedHolder.getAttribute(a.attributes$4.minimum))
          : 1;
        const checkRecentInRelated = !recentlyViewedWrapper && recentProducts.length > 0;
        const checkRecentOutsideRelated = recentlyViewedWrapper && recentProducts.length >= minimumNumberProducts;

        if (checkRecentInRelated || checkRecentOutsideRelated) {
          this.recentProductGrid = new ProductGrid(recentlyViewedHolder);
          this.initTooltips(recentlyViewedHolder);

          if (checkRecentOutsideRelated) {
            aosItem.forEach((item) => item.classList.remove(c.classes$5.aosInit, c.classes$5.aosAnimate));
            container.classList.remove(c.classes$5.hidden);

            requestAnimationFrame(() => aosItem.forEach((item) => item.classList.add(c.classes$5.aosInit)));
          }

          if (slider) {
            this.recentGridSlider = new GridSlider(recentlyViewedHolder);

            requestAnimationFrame(() => {
              this.recentGridSlider.sliders.forEach((slider) => {
                slider.dispatchEvent(new CustomEvent('theme:slider:resize', { bubbles: true }));
                this.recentGridSlider.setSliderArrowsPosition(slider);
              });
            });
          }
        }
      },
    });
  }

  hideRelated() {
    const tab = this.relatedProducts.closest(s.selectors$5.tab);
    const tabsHolder = this.relatedProducts.closest(s.selectors$5.tabsHolder);
    const tabsLink = tabsHolder.querySelector(`[${a.attributes$4.tabsLink}="${tab.dataset.tab}"]`);

    tab.remove();

    if (!tabsLink) return;
    tabsLink.remove();
    tabsHolder.querySelector(s.selectors$5.tabsLink).dispatchEvent(new Event('click'));
    this.tabs.customScrollbar.unload();
    requestAnimationFrame(() => {
      this.tabs.customScrollbar = new CustomScrollbar(this.tabs.container);
    });
  }

  /**
   * Init tooltips for swatches
   */
  initTooltips(container) {
    this.tooltips = container.querySelectorAll(s.selectors$5.tooltip);
    this.tooltips.forEach((tooltip) => {
      new Tooltip(tooltip);
    });
  }

  /**
   * Event callback for Theme Editor `section:deselect` event
   */
  onDeselect() {
    if (this.relatedProductGrid) this.relatedProductGrid.onDeselect();
    if (this.recentProductGrid) this.recentProductGrid.onDeselect();
  }

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {
    if (this.relatedProductGrid) this.relatedProductGrid.onUnload();
    if (this.relatedGridSlider) this.relatedGridSlider.onUnload();
    if (this.recentProductGrid) this.recentProductGrid.onUnload();
    if (this.recentGridSlider) this.recentGridSlider.onUnload();
  }
}